import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { getFormattedDate } from './eosCreateWorkItem'

const responseParser = (response: any) => {
  console.log('htag responseParser', response)
  return response
}

const updateProcessingEntityConfig = (reqParms: any) => {
  reqParms.value = JSON.parse(reqParms.entityFileData)
  delete reqParms.entityFileData
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.updateProcessingEntityConfig),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: {
      workflowId: `PEU-${getFormattedDate()}`,
      requestType: 'PROCESSING_ENTITY_UPSERT',
      processingEntityConfiguration: reqParms,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateProcessingEntityConfig }
